import {
   ANNUAL_MILEAGE_OPTIONS,
   insurancePaymentTypesForVans,
   NCD_EARNING_OPTIONS,
   NCD_EARNING_PLACE_OPTIONS,
   NO_CLAIMS_DISCOUNT_OPTIONS,
   PARKING_DURING_DAY_OPTIONS,
   PARKING_DURING_NIGHT_OPTIONS,
   VAN_BUSINESS_TYPE_OPTIONS,
   VAN_INSURANCE_COVERAGE_TYPE_OPTIONS,
   VAN_OWNER_TYPE_OPTIONS,
   VAN_USAGE_TYPE_OPTIONS,
   VOLUNTARY_EXCESS_AMOUNT_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";

import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";

export default function VehicleUsage({data, handlers, setCurrentStep}) {

    return (
        <div className="vehicle-usage">


            <div className="row">

                {/* Where's the van kept during the day? */}

                <ScrollableDropdownBlock
                    controlName="vanParkingAtDay"
                    containerCssClass="col-12 py-3 "
                    labelText="Where's the van kept during the day?"
                    required={true}
                    options={PARKING_DURING_DAY_OPTIONS}
                    selectedValues={data.vanParkingAtDay}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                <ScrollableDropdownBlock
                    controlName="vanParkingAtNight"
                    containerCssClass="col-12 py-3 "
                    labelText="Where's the van kept during the day?"
                    required={true}
                    options={PARKING_DURING_NIGHT_OPTIONS}
                    selectedValues={data.vanParkingAtNight}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Is the vehicle kept at the same address? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Is the vehicle kept at the same address?"
                    required={true}
                    controlName="isVanKeptOnSameAddress"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isVanKeptOnSameAddress}
                    onChange={handlers.onControlChange}
                />


                {data.isVanKeptOnSameAddress === 'No' && (

                    <>
                        {/* If No, what is the full address of where the vehicle is kept? */}

                        <ScrollableTextBoxBlock
                            containerCssClass="col-12 py-3 "
                            labelText="If No, what is the full address of where the vehicle is kept?"
                            required={data.isVanKeptOnSameAddress === 'No'}
                            controlName="vehicleKeeperAddress"
                            value={data.vehicleKeeperAddress}
                            onChange={handlers.onControlChange}
                            inputAttrs={{
                                maxLength: 50,
                                rows: 4
                            }}
                            asTextArea={true}
                        />
                    </>

                )}

                {/*
                Registered keeper ...
            */}

                <div className="row">

                    {/* Registered keeper */}

                    <ScrollableDropdownBlock
                        controlName="registeredKeeper"
                        containerCssClass="col-12 py-3 "
                        labelText="Registered keeper"
                        required={true}
                        options={VAN_OWNER_TYPE_OPTIONS}
                        selectedValues={data.registeredKeeper}
                        onChange={handlers.onControlChange}
                        helpText=""
                    />

                    {/* Legal owner */}

                    <ScrollableDropdownBlock
                        controlName="legalOwner"
                        containerCssClass="col-12 py-3 "
                        labelText="Legal owner"
                        required={true}
                        options={VAN_OWNER_TYPE_OPTIONS}
                        selectedValues={data.legalOwner}
                        onChange={handlers.onControlChange}
                        helpText=""
                    />

                    {/* Carriage of dangerous goods */}

                    <ScrollableButtonGroupBlock
                        containerCssClass="col-12 py-3 "
                        labelText="Carriage of dangerous goods"
                        required={true}
                        controlName="carriageOfDangerousGoods"
                        options={YES_NO_CHOICE_OPTIONS}
                        selectedValues={data.carriageOfDangerousGoods}
                        onChange={handlers.onControlChange}
                    />

                </div>

                {/*  Have you or any of the drivers ever had insurance declined, cancelled or special terms
                        imposed? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Have you or any of the drivers ever had insurance declined, cancelled or special terms
                        imposed?"
                    required={true}
                    controlName="wasInsuranceDeclinedBefore"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.wasInsuranceDeclinedBefore}
                    onChange={handlers.onControlChange}
                />

                {data.wasInsuranceDeclinedBefore === 'Yes' && (

                    <>
                        {/* What is the name of insurer? */}

                        <ScrollableTextBoxBlock
                            containerCssClass="col-12 py-3 "
                            labelText="What is the name of insurer?"
                            required={true}
                            controlName="insurerName"
                            value={data.insurerName}
                            onChange={handlers.onControlChange}
                            inputAttrs={{
                                maxLength: 50
                            }}
                        />

                    </>

                )}

                {/* Use of vehicle */}

                <ScrollableDropdownBlock
                    controlName="vehicleUsageType"
                    containerCssClass="col-12 py-3 "
                    labelText="Use of vehicle"
                    required={true}
                    options={VAN_USAGE_TYPE_OPTIONS}
                    selectedValues={data.vehicleUsageType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Estimated annual mileage */}

                <ScrollableDropdownBlock
                    controlName="estimatedAnnualMileage"
                    containerCssClass="col-12 py-3 "
                    labelText="Estimated annual mileage"
                    required={true}
                    options={ANNUAL_MILEAGE_OPTIONS}
                    selectedValues={data.estimatedAnnualMileage}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Type of business */}

                <ScrollableDropdownBlock
                    controlName="vanBusinessType"
                    containerCssClass="col-12 py-3 "
                    labelText="Type of business"
                    required={true}
                    options={VAN_BUSINESS_TYPE_OPTIONS}
                    selectedValues={data.vanBusinessType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Type of cover */}

                <ScrollableDropdownBlock
                    controlName="insuranceCoverageType"
                    containerCssClass="col-12 py-3 "
                    labelText="Type of cover"
                    required={true}
                    options={VAN_INSURANCE_COVERAGE_TYPE_OPTIONS}
                    selectedValues={data.insuranceCoverageType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Any no claims discount? */}

                <ScrollableDropdownBlock
                    controlName="noClaimsDiscount"
                    containerCssClass="col-12 py-3 "
                    labelText="Any no claims discount?"
                    required={true}
                    options={NO_CLAIMS_DISCOUNT_OPTIONS}
                    selectedValues={data.noClaimsDiscount}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* How did you earn your no claims discount: * */}

                <ScrollableDropdownBlock
                    controlName="howNCDWasEarned"
                    containerCssClass="col-12 py-3 "
                    labelText="How did you earn your no claims discount: *"
                    required={true}
                    options={NCD_EARNING_OPTIONS}
                    selectedValues={data.howNCDWasEarned}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* was the NCD earned in UK? */}

                <ScrollableDropdownBlock
                    controlName="whereNCDWasEarned"
                    containerCssClass="col-12 py-3 "
                    labelText="Was the NCD earned in UK?"
                    required={true}
                    options={NCD_EARNING_PLACE_OPTIONS}
                    selectedValues={data.whereNCDWasEarned}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Would you like to protect NCD? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Would you like to protect NCD?"
                    required={true}
                    controlName="protectNCDForVehicle"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.protectNCDForVehicle}
                    onChange={handlers.onControlChange}
                />

                {/* What voluntary excess would you like? */}

                <ScrollableDropdownBlock
                    controlName="voluntaryExcessAmounts"
                    containerCssClass="col-12 py-3 "
                    labelText="What voluntary excess would you like?"
                    required={false}
                    options={VOLUNTARY_EXCESS_AMOUNT_OPTIONS}
                    selectedValues={data.voluntaryExcessAmounts}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* How do you normally pay for insurance? */}

                <ScrollableDropdownBlock
                    controlName="insurancePaymentType"
                    containerCssClass="col-12 py-3 "
                    labelText="How do you normally pay for insurance?"
                    required={true}
                    options={insurancePaymentTypesForVans}
                    selectedValues={data.insurancePaymentType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Please provide your current/previous insurer’s name */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Please provide your current/previous insurer’s name"
                    required={false}
                    controlName="insurerName"
                    value={data.insurerName}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/*  How much was your renewal price with the previous insurer ? */}

                <ScrollableTextBoxBlock
                    type="number"
                    containerCssClass="col-12 py-3 "
                    labelText=" How much was your renewal price with the previous insurer ?"
                    required={false}
                    controlName="renewalPriceOfPreviousInsurer"
                    value={data.renewalPriceOfPreviousInsurer}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />


                {/* When do you want the insurance to start ? */}

                <ScrollableCustomDateTimePickerBlock
                    containerCssClass="col-12 py-3 "
                    labelText="When do you want the insurance to start ?"
                    required={true}
                    controlName="insuranceCoverageStartDate"
                    value={data.insuranceCoverageStartDate}
                    onChange={handlers.onControlChange}
                />
                
            </div>
        </div>
    );

}